import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["onBackClick"];
import { Box } from '@wix/design-system';
import React from 'react';
import { BngResultsTitle } from './BngResultsTitle';
import { BngResultsDesktopHeader } from './BngResultsDesktopHeader';
import { useIsMobile } from '../../../hooks/useIsMobile';
export const BngResultsHeaderV2 = _ref => {
  let onBackClick = _ref.onBackClick,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isMobile = useIsMobile();
  if (isMobile) {
    return /*#__PURE__*/React.createElement(Box, {
      width: "100%",
      paddingTop: "SP4",
      paddingLeft: "SP4",
      paddingRight: "SP4",
      align: "center",
      textAlign: "center",
      boxSizing: "border-box"
    }, /*#__PURE__*/React.createElement(BngResultsTitle, null));
  }
  return /*#__PURE__*/React.createElement(BngResultsDesktopHeader, _extends({
    onBackClick: onBackClick
  }, props));
};
//# sourceMappingURL=BngResultsHeaderV2.js.map